import PropTypes from "prop-types";
// @mui
import { Stack, TableCell, TableRow, Typography } from "@mui/material";

// components

// ----------------------------------------------------------------------

VotersTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onEditRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  filterStatus: PropTypes.string,
  markAsPaid: PropTypes.func,
  limit: PropTypes.number,
  page: PropTypes.number,
  onViewRow: PropTypes.func,
  cusId: PropTypes.number,
  fromCustomer: PropTypes.bool,
};

export default function VotersTableRow({ row }) {
  //   const doc = cheerio.load(row?.Description);

  return (
    <>
      <TableRow>
        <TableCell align="left">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Stack direction="column">
              <Typography variant="subtitle2" noWrap>
                {row?.name}
              </Typography>
            </Stack>
          </Stack>
        </TableCell>

        <TableCell align="left">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Stack direction="column">
              <Typography variant="subtitle2" noWrap>
                {row?.phone}
              </Typography>
            </Stack>
          </Stack>
        </TableCell>

        <TableCell align="left">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Stack direction="column">
              <Typography variant="subtitle2" noWrap>
                {row?.email}
              </Typography>
            </Stack>
          </Stack>
        </TableCell>
      </TableRow>
    </>
  );
}
